import React from "react";
import PackagesPage from "../PackagesPage";
import Image from "../../../assets/img/deluxe-off-grid-package.jpg";
import Image2 from "../../../assets/img/deluxe-premium-package.jpg";
import { ReactComponent as PeopleIconComponent } from "../../../assets/img/people-icon.svg";
import { ReactComponent as CheckIconComponent } from "../../../assets/img/check-icon.svg";
import modelNodes from "./modelNodes";

const title = "Deluxe Hot Tub";

const breadcrumbData = [
    {
        title,
        active: true,
    },
    {
        title: "Packages",
        active: false,
    },
];

const checkBoxesData = [
    {
        label: "Deluxe Premium Acrylic Hot Tub Package",
        url: "model/1",
        image: Image,
        oldPrice: 6299,
        price: 5250,
        id: 2,
        modelId: "26cf829470fd4f13a774392f8d3f674a",
        listProps: [
            {
                icon: (
                    <React.Fragment>
                        <PeopleIconComponent />
                    </React.Fragment>
                ),
                text: "Fits 6-8 people",
            },
            {
                icon: (
                    <React.Fragment>
                        <CheckIconComponent />
                    </React.Fragment>
                ),
                text: "Special offer combo",
            },
            {
                text: "Air bubble system",
            },
            {
                text: "Hydro massage system",
            },
            {
                text: "LED multicolour lighting",
            },
        ],
    },
    {
        label: "Deluxe Off-Grid Acrylic Hot Tub Package",
        url: "model/2",
        image: Image2,
        oldPrice: 4999,
        price: 4250,
        id: 3,
        modelId: "0aba2aea027f4069aa28ec575e9eeb1c",
        listProps: [
            {
                icon: (
                    <React.Fragment>
                        <PeopleIconComponent />
                    </React.Fragment>
                ),
                text: "Fits 6-8 people",
            },
            {
                icon: (
                    <React.Fragment>
                        <CheckIconComponent />
                    </React.Fragment>
                ),
                text: "Special offer combo",
            },
        ],
    }
];
const keyFeaturesData = {
    id: 1,
    label: "Design Your Hot Tub",
    price: 2999,
    url: "custom",
    modelId: "2c0d180ee74949d08e9e8662ec9748db",
    modelNodes: modelNodes,
    listProps: [
        {
            text: "Ready to ship in 1-4 weeks",
        },
    ],
};

const limitedOfferIntroData = {
    title: "Deluxe <em>Specials</em>",
    text: "We carry stocks of our most popular Deluxe wood fired hot tubs, so they’re ready to ship as soon as you order. Check out our range of pre-configured models.",
    discount: 17,
};

const headlineData = {
    title: "Deluxe Premium Package",
    discount: 17,
};

const Home = () => (
    <PackagesPage
        title={title}
        breadcrumbData={breadcrumbData}
        checkBoxesData={checkBoxesData}
        keyFeaturesData={keyFeaturesData}
        limitedOfferIntroData={limitedOfferIntroData}
        headlineData={headlineData}
    />
);

export default Home;
